import {
  FunctionComponent,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";
import { Header } from "../components/Header";
import { SocialLinks } from "./SocialLinks";
import ParallaxGlasses from "./ParallaxGlasses";
import ScrollProgress from "./ScrollProgress";
import Footer from "./Footer";

const Layout: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [progress, setProgress] = useState<number>(0);

  useEffect(() => {
    const listener = () => {
      setProgress(
        Math.min(
          100,
          (window.scrollY / (document.body.scrollHeight - window.innerHeight)) *
            100
        )
      );
    };
    document.addEventListener("scroll", listener);
    return () => document.removeEventListener("scroll", listener);
  }, []);
  return (
    <>
      <ScrollProgress progress={progress} />
      <ParallaxGlasses progress={progress} />
      <Header />
      <main className="relative backdrop-blur-sm p-3 mx-auto my-4 max-w-6xl z-10">
        {children}
      </main>
      <Footer />
    </>
  );
};

export default Layout;
